import { useMutation } from '@tanstack/react-query';
import { createDataFlowSchedule } from '@/features/adp/services/api-service';
import type {
  CreateDataFlowScheduleRequest,
  CreateDataFlowScheduleResponse,
} from '@/features/adp/services/api-service.types';

type UseCreateDataFlowScheduleMutationOptions = {
  onSuccess?: (
    data: CreateDataFlowScheduleResponse,
    variables: CreateDataFlowScheduleRequest
  ) => void;
  onError?: (error: Error, variables: CreateDataFlowScheduleRequest) => void;
};

export function useCreateDataFlowScheduleMutation(
  options: UseCreateDataFlowScheduleMutationOptions = {}
) {
  const { onSuccess, onError } = options;

  return useMutation<CreateDataFlowScheduleResponse, Error, CreateDataFlowScheduleRequest>({
    mutationFn: (payload) => createDataFlowSchedule(payload),
    onSuccess: (data, variables) => {
      onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      onError?.(error, variables);
    },
  });
}
